import {
  FETCH_BUILDING_NUMBERS_REQUEST,
  FETCH_BUILDING_NUMBERS_SUCCESS,
  FETCH_BUILDING_NUMBERS_FAILURE,
  SAVE_BUILDING_NUMBER_REQUEST,
  SAVE_BUILDING_NUMBER_SUCCESS,
  SAVE_BUILDING_NUMBER_FAILURE,
  DELETE_BUILDING_NUMBER_REQUEST,
  DELETE_BUILDING_NUMBER_SUCCESS,
  DELETE_BUILDING_NUMBER_FAILURE,
} from './types';

const INITIAL_STATE = {
  buildingNumberList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BUILDING_NUMBERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_BUILDING_NUMBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        buildingNumberList: action.payload,
      };

    case FETCH_BUILDING_NUMBERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        buildingNumberList: [],
      };
    case SAVE_BUILDING_NUMBER_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_BUILDING_NUMBER_SUCCESS:
      return {
        ...state,
      };

    case SAVE_BUILDING_NUMBER_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_BUILDING_NUMBER_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_BUILDING_NUMBER_SUCCESS:
      return {
        ...state,
      };

    case DELETE_BUILDING_NUMBER_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
